import { render, staticRenderFns } from "./ServiceListDialog.vue?vue&type=template&id=22edd988&scoped=true&"
import script from "./ServiceListDialog.vue?vue&type=script&lang=js&"
export * from "./ServiceListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22edd988",
  null
  
)

export default component.exports